import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { values, contains } from "ramda"
import Actions from "../../redux/wizard.redux"
import StepCalculator from "./step-calculator.component"
import StepEstimate from "./step-estimate.component"

import Box from "../../lib/ui/ui-box"

const MAP_QUESTIONS_TO_PAGE = {
  1: "Estimating how much cash you can get.",
  2: "End"
}

class WizardForm extends Component {
  componentDidMount() {
    this.handleOnViewed()
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.page !== prevProps.match.params.page) {
      this.handleOnViewed()
    }
  }

  nextPage = () => {
    const { history, match, intl } = this.props
    const page = Number(match.params.page)
    history.push(
      `${intl.formatMessage({ id: "routes.calculator" })}/${page + 1}`
    )
  }

  previousPage = () => {
    const { history, match, intl } = this.props
    const page = Number(match.params.page)
    history.push(
      `${intl.formatMessage({ id: "routes.calculator" })}/${page - 1}`
    )
  }

  handleOnUpdatedAnswer = () => {
    const { match } = this.props
    const page = Number(match.params.page)
    this.props.analyticsQuestionAnswered(page, {
      eventName: "updated answer",
      category: "questions",
      label: `${page} | ${MAP_QUESTIONS_TO_PAGE[page]}`,
      location: "calculate amount",
      question_id: page,
      question_name: MAP_QUESTIONS_TO_PAGE[page],
      step: page
    })
  }

  handleOnViewed = () => {
    const { match } = this.props
    const page = Number(match.params.page)
    this.props.analyticsQuestionViewed(page, {
      eventName: "viewed question",
      category: "questions",
      label: `${page} | ${MAP_QUESTIONS_TO_PAGE[page]}`,
      location: "calculate amount",
      question_id: page,
      question_name: MAP_QUESTIONS_TO_PAGE[page],
      step: page
    })
  }

  render() {
    const { match, stepValidationMap } = this.props
    const page = Number(match.params.page)
    const isFlowInvalid = contains(false, values(stepValidationMap))
    return (
      <Box flexDirection="column" pl={[4]}>
        <Box mb={[3]}>
          {match.params.page === "1" && (
            <StepCalculator
              {...this.props}
              isFlowInvalid={isFlowInvalid}
              onSubmit={() => {
                this.props.analyticsQuestionAnswered(page, {
                  eventName: "updated answer",
                  category: "questions",
                  label: `${page} | ${MAP_QUESTIONS_TO_PAGE[page]}`,
                  location: "calculate amount",
                  question_id: page,
                  question_name: MAP_QUESTIONS_TO_PAGE[page],
                  step: page
                })
                this.nextPage()
              }}
            />
          )}
          {match.params.page === "2" && (
            <StepEstimate
              {...this.props}
              loanMaxAmount={this.props.loanMaxAmount}
              isFlowInvalid={isFlowInvalid}
              onSubmit={this.props.submit}
            />
          )}
        </Box>
      </Box>
    )
  }
}

WizardForm.propTypes = {
  // stepValidationMap: PropTypes.object.isRequired
  stepValidationMap: PropTypes.object
}

const mapDispatchToProps = dispatch => {
  return {
    submit: () => dispatch(Actions.submitNew()),

    analyticsQuestionAnswered: (currentStep, value) =>
      dispatch(
        Actions.analyticsQuestionAnswered("CALCULATOR", currentStep, value)
      ),
    analyticsQuestionViewed: (currentStep, value) =>
      dispatch(
        Actions.analyticsQuestionViewed("CALCULATORs", currentStep, value)
      )
  }
}
export default connect(null, mapDispatchToProps)(WizardForm)



// WEBPACK FOOTER //
// ./src/components/new-mortgage-wizard/new-mortgage-wizard.component.js